<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="contact-page">
    <!-- HERO -->
    <section class="page-hero">
      <div class="page-hero-inner">
        <div class="section-label">Get in Touch</div>
        <h1 class="page-title">聯絡我們</h1>
        <p class="page-sub">
          若您有任何疑問或需要協助，歡迎透過電子郵件或電話與我們聯繫，我們將樂意為您提供協助。
        </p>
      </div>
    </section>

    <!-- CONTACT INFO -->
    <section class="contact-info-section">
      <div class="contact-info-inner">
        <div class="info-item">
          <div class="info-icon">📍</div>
          <div class="info-label">聯絡地址</div>
          <div class="info-value">中壢區元化路271巷26弄56號</div>
        </div>
        <div class="info-item">
          <div class="info-icon">📞</div>
          <div class="info-label">電話</div>
          <div class="info-value">0910-206-148</div>
        </div>
        <div class="info-item">
          <div class="info-icon">✉️</div>
          <div class="info-label">Email</div>
          <div class="info-value">Greenrichgeam@gmail.com</div>
        </div>
      </div>
    </section>

    <!-- FORM -->
    <section class="contact-form-section">
      <div class="contact-form-inner">
        <div class="form-card">
          <h2 class="form-title">填寫詢問表單</h2>
          <p v-if="prefilledProduct" class="form-prefill-note">
            關於商品「{{ prefilledProduct }}」的詢問
          </p>

          <div class="form-row">
            <div class="form-group">
              <label>您的姓名 *</label>
              <input type="text" v-model="form.name" placeholder="王小明" />
            </div>
            <div class="form-group">
              <label>電子郵件 *</label>
              <input
                type="email"
                v-model="form.email"
                placeholder="name@company.com"
              />
            </div>
          </div>

          <div class="form-group">
            <label>聯絡電話</label>
            <input type="tel" v-model="form.phone" placeholder="09xx-xxx-xxx" />
          </div>

          <div class="form-group">
            <label>詢問類別</label>
            <select v-model="form.type">
              <option>個人購買</option>
              <option>企業植栽租賃</option>
              <option>企業合作 / ESG 專案</option>
              <option>禮贈客製服務</option>
              <option>園藝療癒課程</option>
              <option>其他問題</option>
            </select>
          </div>

          <div class="form-group">
            <label>詢問內容</label>
            <textarea
              v-model="form.message"
              placeholder="請描述您的需求或問題，我們將盡快回覆..."
            ></textarea>
          </div>

          <button class="btn-submit" @click="submitForm" :disabled="submitting">
            {{
              formDone
                ? "✓ 已送出！我們將盡快回覆您"
                : submitting
                ? "送出中..."
                : "送出詢問"
            }}
          </button>
          <p v-if="errorMsg" class="form-error">{{ errorMsg }}</p>
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer class="footer">
      <div class="footer-inner">
        <p>© 2026 綠憩植研 Green Rich Geam. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

const route = useRoute();
const prefilledProduct = ref("");

const form = reactive({
  name: "",
  email: "",
  phone: "",
  type: "個人購買",
  message: "",
});

const submitting = ref(false);
const formDone = ref(false);
const errorMsg = ref("");

onMounted(() => {
  // 從 Products.vue「詢問購買」按鈕帶過來的商品名稱，自動帶入詢問內容
  const productName = route.query.product;
  if (productName) {
    prefilledProduct.value = productName;
    form.type = "個人購買";
    form.message = `我想詢問「${productName}」的相關資訊。`;
  }
});

const submitForm = async () => {
  errorMsg.value = "";

  if (!form.name || !form.email) {
    errorMsg.value = "請填寫姓名與電子郵件";
    return;
  }

  submitting.value = true;
  try {
    await axios.post("/contact/submit", form);
    formDone.value = true;
    form.name = "";
    form.email = "";
    form.phone = "";
    form.type = "個人購買";
    form.message = "";
    prefilledProduct.value = "";
    setTimeout(() => {
      formDone.value = false;
    }, 3000);
  } catch (error) {
    console.error("提交表單失敗:", error);
    errorMsg.value = "提交失敗，請稍後重試，或直接透過電話/Email聯絡我們";
  } finally {
    submitting.value = false;
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.contact-page {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

/* HERO */
.page-hero {
  background: linear-gradient(135deg, #2d5016 0%, #4e7b4f 100%);
  color: white;
  padding: 80px 40px;
  text-align: center;
}

.page-hero-inner {
  max-width: 600px;
  margin: 0 auto;
}

.section-label {
  font-size: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 16px;
}

.page-title {
  font-size: 3em;
  font-weight: 600;
  margin-bottom: 16px;
}

.page-sub {
  font-size: 1em;
  opacity: 0.85;
  line-height: 1.7;
}

/* CONTACT INFO */
.contact-info-section {
  background: #f0f4f0;
  padding: 60px 40px;
}

.contact-info-inner {
  max-width: 900px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  text-align: center;
}

.info-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.info-label {
  font-size: 14px;
  font-weight: 700;
  color: #1c2b1a;
  margin-bottom: 8px;
}

.info-value {
  font-size: 14px;
  color: #4e7b4f;
}

/* FORM */
.contact-form-section {
  max-width: 700px;
  margin: 80px auto;
  padding: 0 40px;
}

.form-card {
  background: white;
  border-radius: 20px;
  padding: 48px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.form-title {
  font-size: 22px;
  color: #1c2b1a;
  margin-bottom: 8px;
}

.form-prefill-note {
  font-size: 13px;
  color: #4e7b4f;
  background: #eaf2e0;
  padding: 8px 14px;
  border-radius: 8px;
  margin-bottom: 24px;
  display: inline-block;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3d4f3a;
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: #1c2b1a;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #4e7b4f;
}

.form-group textarea {
  min-height: 120px;
  resize: vertical;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: #4e7b4f;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-submit:hover:not(:disabled) {
  background: #2d5016;
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.form-error {
  color: #ff6b6b;
  font-size: 14px;
  text-align: center;
  margin-top: 12px;
}

/* FOOTER */
.footer {
  background: #1c2b1a;
  color: #9baa97;
  text-align: center;
  padding: 40px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 2em;
  }

  .contact-info-inner {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-card {
    padding: 32px 24px;
  }
}
</style>
